








import {
  Vue,
  Component,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";

@Component ({
  components: {
    GenericLoadingSpinner
  }
})
export default class Settings extends Vue {
  mounted () {
    document.getElementsByClassName("header-container")[0].setAttribute("style", "display: none;");
    }
}
